var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "20px",
    viewBox: "0 0 64 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle Copy 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Member_Q2_M",
    transform: "translate(-191.000000, -77.000000)",
    fill: "#E5744B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-4",
    transform: "translate(121.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.497636,0 L133,0 C133.552285,-1.01453063e-16 134,0.44771525 134,1 L134,19 C134,19.5522847 133.552285,20 133,20 L71.497636,20 C70.9453513,20 70.497636,19.5522847 70.497636,19 C70.497636,18.7265498 70.6096158,18.4650279 70.8075084,18.2763123 L78.7274075,10.7236877 C79.1270892,10.3425407 79.1421145,9.70955402 78.7609675,9.30987236 C78.7500479,9.29842176 78.7388581,9.28723193 78.7274075,9.27631233 L70.8075084,1.72368767 C70.4078267,1.34254069 70.3928014,0.709554019 70.7739484,0.309872358 C70.9626639,0.111979803 71.2241858,-2.82834916e-16 71.497636,0 Z",
    id: "Rectangle-Copy-10"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightM);
export default __webpack_public_path__ + "static/media/rightM.6c0d15d2d079833374d757b6ba06d551.svg";
export { ForwardRef as ReactComponent };